<template>
  <div class="order-card dea-border-grey-medium">
    <div class="order-card__header">
      <h2 class="dea-heading--medium__m">Numero d'ordine: {{ order.id }}</h2>
      <span>{{ order.date_fmt }}</span>
    </div>
    <div class="order-card__registrations-list">
      <div v-for="registration in order.registrations" :key="registration.id" class="order-card__registration">
        <Badge :class="registration.linked_event.bgMod" class="dea-heading--regular__xxs">
          {{ registration.linked_event.type_label }}
        </Badge>
        <div class="order-card__registration-title dea-heading--light__xs">{{ registration.linked_event.title }}</div>
        <div class="order-card__registration-price dea-heading--medium__s">
          {{
            registration.sale_price != 0 && registration.sale_price !== null ? `${registration.sale_price} €` : "free"
          }}
        </div>
      </div>
    </div>
    <div class="order-card__footer">
      <div class="dea-heading--light__xs">TOTALE</div>
      <div class="dea-heading--medium__s">
        {{ order.sale_price != 0 && order.sale_price !== null ? `${order.sale_price} €` : "free" }}
      </div>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/elements/Badge";

export default {
  name: "OrderCard",
  components: { Badge },
  props: {
    order: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.order-card {
  border: $border-light;
  border-radius: $border-radius-medium;
  margin-bottom: $space-base;
  padding: $space-small;

  &__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-bottom: $space-base;

    h2 {
      margin: 0;
      word-break: break-word;
    }
  }

  &__registration {
    @include media("<=xs") {
      display: block;
    }

    align-items: center;
    display: flex;
    margin-bottom: $space-base;

    &-title {
      @include media("<=xs") {
        margin-bottom: $space-x-small;
        margin-left: 0;
        margin-top: $space-x-small;
      }

      margin-left: $space-x-small;
    }

    &-price {
      margin-left: auto;
    }
  }

  &__footer {
    text-align: right;
  }
}
</style>
